import { SourcingChannelDetails } from 'api-clients/monolith';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { PlaneSendIcon } from '@/components/icons/plane-send';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';
import { useHireUrl } from '@/hooks/use-hire-url';
import { BOOST, INDEED, SPRING } from '@/types/channels';

import { useChannelsStore } from '../use-channels-store';
import { Card } from './card';
import { useMessages } from './messages';

interface ChannelRecommendationProps {
  channels: SourcingChannelDetails[];
}

export function ChannelRecommendation({
  channels,
}: ChannelRecommendationProps) {
  const { getChannelRecommendationMessages } = useMessages();
  const { header, description } = getChannelRecommendationMessages();
  const { getHireSourcingUrl } = useHireUrl();
  const openingId = useChannelsStore(s => s.opening?.id);

  const isSingleKnownChannel =
    channels.length === 1 && [INDEED, SPRING, BOOST].includes(channels[0].slug);

  // If there is a single channel and one of INDEED, SPRING, BOOST, show the channel name and a button to post the job
  // Otherwise show the channels in a list
  return (
    <Card header={header} description={description}>
      {isSingleKnownChannel ? (
        <Button variant="secondary" asChild>
          <Link
            to={getHireSourcingUrl(channels[0].slug, openingId)}
            target="_blank"
          >
            <PlaneSendIcon />
            <FormattedMessage
              defaultMessage="Post Job to {channel}"
              values={{ channel: channels[0].name }}
            />
          </Link>
        </Button>
      ) : (
        <div className="flex gap-1">
          <Typography variant="subtitle1">
            <FormattedMessage defaultMessage="Channels:" />
          </Typography>
          <Typography variant="subtitle2">
            {channels.map(channel => channel.name).join(', ')}
          </Typography>
        </div>
      )}
    </Card>
  );
}
